import { render } from "./Requests.vue?vue&type=template&id=a4ca57e2"
import script from "./Requests.vue?vue&type=script&lang=js"
export * from "./Requests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__